<footer>
    <div class="light">
        <div class="footer-inner">
            <span class="flex-start">
                <a class="footer-image" href="http://www.finkn.no/" target="_blank">
                    <img src="/assets/images/logo-short.png" />
                </a>
                <span>
                    <mat-icon fontSet="material-icons-outlined">corporate_fare</mat-icon>&nbsp;Org. nr 971 437 022
                </span>
            </span>

            <span class="flex-end">
                <mat-icon fontSet="material-icons-outlined">email</mat-icon>&nbsp;<a
                    href="https://www.finkn.no/Om-oss?id=96#96">Kontakt oss</a>
            </span>

        </div>
    </div>
    <div class="dark">
        <div class="footer-inner">
            Opplever du systemfeil? Send en e-post til
            <a href="mailto:feilmelding@finkn.no">
                feilmelding&#64;finkn.no
            </a>
        </div>
    </div>

</footer>